import { JSONObject } from '@amzn/aws-d2c-data-layer/dist/types';
import { CONFIG_ELEM_ID } from '../constants/elements';
import { D2CAnalyticsConfigExternal } from '@amzn/aws-d2c-client-plugins/dist/interfaces';

declare global {
  interface Window {
    AWSMA: Record<string, any>; // eslint-disable-line no-var, @typescript-eslint/no-explicit-any
  }
}
// Note: when allowedURLParams and ignoredURLParams are both provided, allowedURLParams is used
export type CustomConfigProps = {
  customPageview?: boolean;
  scrollElement?: string;
  ignoredURLParams?: Array<string>;
  allowedURLParams?: Array<string>;
  pageType?: string;
  impressionTime?: number;
  impressionThreshold?: number;
  sanitizeData?: (data: JSONObject) => JSONObject;

  // Keeping the rest of the fields untouched for now.
  // TODO: Merge similar fields from above to be inside this config later on.
  eventTrackerConfig?: D2CAnalyticsConfigExternal;
};

export default class CustomConfig {
  private static configFromJson: Record<string, unknown>;
  static config: CustomConfigProps;

  static get(): CustomConfigProps {
    this.config = Object.assign({}, this.configFromJson, window.AWSMA.config || {});

    return this.config;
  }

  static {
    window.AWSMA = window.AWSMA || {};
    window.AWSMA.TRIGGER_EVENT = 'custom_awsma_trigger';
    const configElement = document.getElementById(CONFIG_ELEM_ID);
    this.configFromJson = getConfigJson(configElement);
  }
}

// The elem parameter is expected to contain JSON text.
// <script type="application/json">
// { "pageType": "Test Page", "ignoredURLParams": ["token"] }
// </script>
// Returns the content of the script element as an object.
function getConfigJson(elem: HTMLElement | null): Record<string, unknown> {
  let configJson = {};

  if (elem === null || !elem.textContent) {
    return configJson;
  }

  try {
    configJson = JSON.parse(elem.textContent);
  } catch (e) {
    console.error(e);
  }

  return configJson;
}
